import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getHackathonById } from "../../store/hackathonSlice";
import PageTitle from "../../components/PageTitle";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateStr).toLocaleDateString(undefined, options);
};

function HackathonDetail() {
  const { id } = useParams();
  const [hackathon, setHackathon] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchHackathon = async () => {
      const result = await dispatch(getHackathonById(id)).unwrap();
      setHackathon(result);
    };
    fetchHackathon();
  }, [dispatch, id]);

  if (!hackathon) return <p className="mt-32 text-center">Loading...</p>;

  return (
    <div className="mt-32 max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-10 border border-gray-100">
      <PageTitle title={`${hackathon.Title} | Hackathons`} />

      {/* Title & Organizer */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-extrabold text-indigo-700">
          {hackathon.Title}
        </h1>
        <p className="text-lg text-gray-600 mt-2 font-medium">
          {hackathon.Organizer}
        </p>
      </div>

      {/* Details (left aligned) */}
      <div className="space-y-2 text-gray-700 text-left">
        <p>
          <span className="font-semibold">Start Date:</span>{" "}
          {formatDate(hackathon.startDate)}
        </p>
        <p>
          <span className="font-semibold">End Date:</span>{" "}
          {formatDate(hackathon.endDate)}
        </p>
        <p>
          <span className="font-semibold">Mode:</span> {hackathon.mode}
        </p>
      </div>

      {/* Description (left aligned) */}
      <div className="prose max-w-none mt-6 text-gray-700 text-left">
        <div dangerouslySetInnerHTML={{ __html: hackathon.description }} />
      </div>

      {/* Register button (right aligned at bottom) */}
      {hackathon.registrationLink && (
        <div className="mt-8 flex justify-end">
          <a
            href={hackathon.registrationLink}
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2.5 bg-indigo-600 text-white font-medium rounded-lg shadow-md hover:bg-indigo-700 transition"
          >
            Register Here
          </a>
        </div>
      )}
    </div>
  );
}

export default HackathonDetail;
